<script>
export default {
  name: 'DropdownShifter',
  props: {
    opened: Boolean,
    center: Boolean,
  },
  data() {
    return {
      top: 0,
      left: 0,
    };
  },
  computed: {
    styles() {
      return this.center
        ? { transform: `translate(calc(50% + ${this.left}px), ${this.top}px)` }
        : { transform: `translate(${this.left}px, ${this.top}px)` };
    },
  },
  watch: {
    opened: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.top = 0;
          this.left = 0;
          return;
        }

        const fixer = () => {
          const windowWidth = document.body.clientWidth;
          const windowHeight = window.innerHeight;
          // const { scrollHeight: windowHeight, scrollWidth: windowWidth } = document.body;
          const { top, bottom, left, right } = this.$el.getBoundingClientRect(); // eslint-disable-line

          if (top < 0) {
            this.top = -top;
          } else if (bottom > windowHeight) {
            this.top = windowHeight - bottom;
          }

          if (left < 0) {
            this.left = -left;
          } else if (right > windowWidth) {
            this.left = windowWidth - right;
          }
        };

        // this.$nextTick(fixer);
        setTimeout(fixer, 1);
      },
    },
  },
};
</script>

<template lang="pug">
  .dropdown-shifter(v-if="opened" :style="styles")
    slot(:top="top" :left="left")
</template>

<style scoped lang="scss">
.dropdown-shifter {
  max-height: 100vh;
  max-width: 100vw;
}
</style>
